const initialState = {
  data: null,
}

const authenticationReducer = (state = initialState, action) => {
  switch (action.type) {
      case 'UPDATE_AUTHENTICATION': {
          return {
              data: action.payload,
          }
      }

      default:
          return state;
  }
}

export default authenticationReducer;
